<section class="card">
  <div class="card-body">
    <h2 class="h5 mb-3">Pendencias de ponto</h2>

    <app-filtros-pendencia-ponto
      [empregadores]="empregadores"
      [(empregadorSelecionado)]="empregadorSelecionado"
      [departamentos]="departamentos"
      [departamentoSelecionado]="departamentoSelecionado"
      [funcionariosFiltrados]="funcionariosFiltrados"
      [(buscaFuncionario)]="buscaFuncionario"
      [dataInicial]="dataInicial"
      [dataFinal]="dataFinal"
      [rotuloFuncionario]="rotuloFuncionario"
      [detalheFuncionario]="detalheFuncionario"
      (alterarEmpregador)="alterarEmpregador.emit()"
      (departamentoSelecionadoChange)="alterarDepartamento($event)"
      (digitouFuncionario)="alterarBuscaFuncionario($event)"
      (selecionarFuncionario)="selecionarFuncionario($event)"
      (abrirModalFuncionario)="abrirModalFuncionarios()"
      (dataInicialChange)="dataInicial = $event"
      (dataFinalChange)="dataFinal = $event"
      (pesquisar)="pesquisar()"
      (limpar)="limpar()"
      (imprimir)="imprimir()">
    </app-filtros-pendencia-ponto>

    <app-grade-pendencia-ponto [linhas]="linhas" [pesquisado]="pesquisado"></app-grade-pendencia-ponto>
  </div>
</section>

<app-modal-funcionario-exportacao
  [aberta]="modalFuncionariosAberta"
  [(termo)]="buscaFuncionarioModal"
  [funcionarios]="funcionariosModal"
  [rotuloFuncionario]="rotuloFuncionario"
  [detalheFuncionario]="detalheFuncionario"
  (selecionar)="selecionarFuncionario($event)"
  (limpar)="limparBuscaFuncionarioModal()"
  (fechar)="fecharModalFuncionarios()">
</app-modal-funcionario-exportacao>
